export default "/images/es.svg?31eca1057bbcae16093c9162d12d473b";